import { History } from "@widgets/wallet";
import { FC } from "react";

export const WalletHistoryPage: FC = () => {
  return <History />;
};
